var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.tabsName,
            callback: function ($$v) {
              _vm.tabsName = $$v
            },
            expression: "tabsName",
          },
        },
        _vm._l(_vm.tabsConfig, function (tab) {
          return _c(
            "el-tab-pane",
            { key: tab.name, attrs: { label: tab.label, name: tab.name } },
            [
              tab.tips
                ? _c("el-alert", {
                    attrs: {
                      title: tab.tips,
                      type: "info",
                      "show-icon": "",
                      closable: false,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _vm.tabsName === "1"
        ? [
            _c(
              "el-table",
              {
                staticClass: "table-wrap",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  border: "",
                  "header-cell-style": _vm.headerCellStyle,
                  "row-style": _vm.rowStyle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "province_name", label: "省份" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            ["合计", "总计"].includes(scope.row.province_name)
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.province_name)),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "clickable",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClickProvinceName(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.province_name))]
                                ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2137087930
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "order_num", label: "订单数" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.order_num) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    126255450
                  ),
                }),
                _c(
                  "el-table-column",
                  { attrs: { prop: "seat_num" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("座位数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "客户购买的电影座位总数量（即售出总票数，1张票对应1个座位）",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "avg_price" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("平均单价")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "平均单价 = 消费点数 / 座位数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "amount" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费点数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "订单消费点数 = 卡消费点数 - 退回卡点数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "consume_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " + _vm._s(row.consume_rate + "%") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1790288032
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费占比")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "当前消费点数 / 总计消费点数 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "cost_a0" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "卡实际分摊真实成本价A0",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "cost_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cost_rate + "%") + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3296176327
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本率")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "成本 / 卡实际分摊抵扣金额 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination__style" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    "page-sizes": [20, 50, 100, 300, 500, 1000],
                    "page-size": _vm.pages.pagesize,
                    "current-page": _vm.pages.page,
                    total: _vm.pages.totalCount,
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.tabsName === "2"
        ? [
            _c(
              "el-form",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "-10px" },
                attrs: { "label-width": "40px", inline: "", size: "mini" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "省份", prop: "province_code" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          clearable: "",
                          filterable: "",
                        },
                        on: { change: _vm.onChangeProvinceCode },
                        model: {
                          value: _vm.filter.province_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "province_code", $$v)
                          },
                          expression: "filter.province_code",
                        },
                      },
                      _vm._l(_vm.provinceOptions, function (province) {
                        return _c("el-option", {
                          key: province.code,
                          attrs: {
                            label: province.fullname,
                            value: province.code,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "城市", prop: "city_code" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          clearable: "",
                          filterable: "",
                          "no-data-text": _vm.filter.province_code
                            ? "无数据"
                            : "请选择省份",
                        },
                        model: {
                          value: _vm.filter.city_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "city_code", $$v)
                          },
                          expression: "filter.city_code",
                        },
                      },
                      _vm._l(_vm.cityOptions, function (city) {
                        return _c("el-option", {
                          key: city.code,
                          attrs: { label: city.fullname, value: city.code },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.onClickSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.searchedWithCateName
              ? _c("el-alert", {
                  attrs: {
                    title: "当前已应用筛选，合计及占比基于筛选结果计算。",
                    type: "warning",
                    closable: false,
                  },
                })
              : _vm._e(),
            _c(
              "el-table",
              {
                staticClass: "table-wrap",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  border: "",
                  "header-cell-style": _vm.headerCellStyle,
                  "row-style": _vm.rowStyle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "province_name", label: "省份" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.province_name) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2684441279
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "city_name", label: "城市" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.city_name) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2118667330
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "order_num", label: "订单数" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.order_num) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    126255450
                  ),
                }),
                _c(
                  "el-table-column",
                  { attrs: { prop: "seat_num" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("座位数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "客户购买的电影座位总数量（即售出总票数，1张票对应1个座位）",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "avg_price" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("平均单价")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "平均单价 = 消费点数 / 座位数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "amount" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费点数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "订单消费点数 = 卡消费点数 - 退回卡点数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "consume_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " + _vm._s(row.consume_rate + "%") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1790288032
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费占比")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "当前消费点数 / 总计消费点数 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "cost_a0" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "卡实际分摊真实成本价A0",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "cost_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cost_rate + "%") + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3296176327
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本率")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "成本 / 卡实际分摊抵扣金额 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination__style" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    "page-sizes": [20, 50, 100, 300, 500, 1000],
                    "page-size": _vm.pages.pagesize,
                    "current-page": _vm.pages.page,
                    total: _vm.pages.totalCount,
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }